import { render, staticRenderFns } from "./pictogram-link.vue?vue&type=template&id=74f6e7ee"
import script from "./pictogram-link.vue?vue&type=script&lang=js"
export * from "./pictogram-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports